<template>
    <div class="state-selector-tooltip oplist-region-selector-wrapper" v-if="showSelector && !isRestricted">
        <div class="flex oplist-top-bar py-2" v-cloak>
            <div class="w-1/2 md:w-4/5 font-bold uppercase">
                <img class="nav-flag float-left mr-2 mt-1 lazyload" width="20" height="20"
                     :data-src="flags[localGeo][currentState]" :alt="regionName + ' flag'">
                <span v-html="regionName" class="localName"></span>
                <span v-if="!sideBar" class="hidden md:inline mr-2">, {{ geoName }}</span>

                <div v-if="emptyList && regionHomepageLink && showOfferAlert"
                     class="oplitstTooltip hidden md:inline-block align-middle">
                     <!-- replace xclick with @click to enable expand/collapse function -->
                    <svg class="tooltipInfo mr-1 inline" xmlns="http://www.w3.org/2000/svg"
                         aria-hidden="true" role="img" width="20" height="20"
                         preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"
                         xclick="expandTooltip = !expandTooltip">
                        <path
                            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-1 4.705c-.07.34.029.533.304.533c.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598c-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081l.082-.381l2.29-.287zM8 5.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2z"/>
                    </svg>
                    <span class="align-middle" v-show="expandTooltip">
                        Online gambling is not available in this state. More information is available
                        <a :href="regionHomepageLink" class="moreInfo"> here</a>
                    </span>
                    <!-- <svg v-show="expandTooltip" class="ml-1 closeTooltip inline align-middle" xmlns="http://www.w3.org/2000/svg"
                         aria-hidden="true" role="img" width="20" height="20"
                         preserveAspectRatio="xMidYMid meet" viewBox="0 0 50 50" @click="expandTooltip = !expandTooltip">
                        <path d="M37.304 11.282l1.414 1.414l-26.022 26.02l-1.414-1.413z" fill="#777"/>
                        <path d="M12.696 11.282l26.022 26.02l-1.414 1.415l-26.022-26.02z" fill="#777"/>
                    </svg> -->
                </div>

                <div v-if="offerState && !sideBar && showOfferAlert" class="hidden md:inline">
                    <div v-if="noOfferAlert" class="oplitstTooltip"
                         v-on:click="noOfferAlert=false;noOfferAlertDisable=true">
                        <svg class="tooltipInfo mr-1" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="20"
                             height="20" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
                            <path
                                d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-1 4.705c-.07.34.029.533.304.533c.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598c-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081l.082-.381l2.29-.287zM8 5.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2z"/>
                        </svg>
                        <span v-if="stateDefault"> No Offers in
                            <span class="cityName" v-html="regionName"></span>.
                        </span>
                        Showing Offers in <span class="cityName" v-html="offerStateName"></span>
                        <svg class="ml-1 closeTooltip" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="20"
                             height="20" preserveAspectRatio="xMidYMid meet" viewBox="0 0 50 50">
                            <path d="M37.304 11.282l1.414 1.414l-26.022 26.02l-1.414-1.413z" fill="#777"/>
                            <path d="M12.696 11.282l26.022 26.02l-1.414 1.415l-26.022-26.02z" fill="#777"/>
                        </svg>
                    </div>
                </div>


                <div v-if="noOfferAlertDisable && showOfferAlert" class="oplitstTooltipDisable hidden md:inline "
                     :class="{ 'md:hidden' : sideBar === false }">
                    <svg class="tooltipInfoDisable" v-on:click="noOfferAlert=true; noOfferAlertDisable=false;"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                         aria-hidden="true" role="img" width="20" height="20" preserveAspectRatio="xMidYMid meet"
                         viewBox="0 0 16 16">
                        <path
                            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-1 4.705c-.07.34.029.533.304.533c.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598c-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081l.082-.381l2.29-.287zM8 5.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2z"/>
                    </svg>
                </div>
            </div>

            <div class="text-right w-1/2 md:w-1/5 px-0 relative">
                <div v-if="noOfferAlertDisable && !sideBar" class="oplitstTooltipDisable md:hidden">
                    <svg class="tooltipInfoDisable" v-on:click="noOfferAlert=true; noOfferAlertDisable=false;"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                         aria-hidden="true" role="img" width="20" height="20" preserveAspectRatio="xMidYMid meet"
                         viewBox="0 0 16 16">
                        <path
                            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-1 4.705c-.07.34.029.533.304.533c.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598c-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081l.082-.381l2.29-.287zM8 5.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2z"/>
                    </svg>
                </div>

                <a @click.prevent :href="'#stateSelectorModal-' + id" class="blue-text ab-testing-location" data-toggle="modal"
                   :data-micromodal-trigger="`stateSelectorModal-${id}`">
                    <img class="lazyload inline ab-testing-img" width="12" height="15"
                         data-src="https://objects.kaxmedia.com/auto/o/139709/196fe493bb.svg"
                         alt="Location Icon">

                    <span class="m-0 font-bold uppercase localName ab-testing-text">EDIT LOCATION</span>
                </a>

                <div class="modal state-selector" :id="'stateSelectorModal-' + id" tabindex="-1" role="dialog"
                     aria-labelledby="slotModalLabel" aria-hidden="true">
                    <div class="modal-overlay" data-micromodal-close></div>
                    <div class="modal-container">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header flex-row-reverse">
                                    <button type="button" class="close font-bold uppercase relative"
                                            data-micromodal-close
                                            data-dismiss="modal" aria-label="Close">
                                        close <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class='modal-body'>
                                    <div class="font-bold uppercase mb-1 mx-1 text-left">locale:</div>

                                    <div class="grey-background region-selector-wrapper">
                                      <v-select class="region-select geo-dropdown" :value="selectedRegion" :clearable="false" label="name" :options="stateData" @input="setSelectedState">
                                        <template v-slot:search="{ attributes, events }">
                                          <div class="input-wrapper">
                                            <input
                                                class="vs__search custom-search"
                                                v-bind="attributes"
                                                v-on="events"
                                                :placeholder="'Search'"
                                            />
                                          </div>
                                        </template>

                                        <template v-slot:option="region">
                                          <img class="select-flag ls-is-cached lazyloaded classic-option" :src="flags[localGeo][region.code]">
                                          <span class="select-text">{{region.name}}</span>
                                        </template>

                                        <template v-slot:selected-option-container="{ option, deselect, multiple, disabled }">
                                          <img class="select-flag ls-is-cached lazyloaded is selected selected-container" :src="flags[localGeo][option.code]">
                                          <span class="select-text">{{option.name}}</span>
                                        </template>

                                        <template v-slot:open-indicator="{ attributes }">
                                          <span class="select-indicator" v-bind="attributes"></span>
                                        </template>
                                      </v-select>
                                    </div>

                                    <button @click="changeRegion" type="button" data-dismiss="modal"
                                            class="update-state" style="display: none;">Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-on:click="noOfferAlert=false;noOfferAlertDisable=true" v-if="noOfferAlert && offerState"
             class="flex flex-wrap  items-center no-gutters oplitstTooltipSmall"
             :class="{ 'md:hidden' : sideBar === false }">
            <div class="col-auto">
                <svg class="tooltipInfo mr-1" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="20" height="20"
                     preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
                    <g fill="#333333">
                        <path
                            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-1 4.705c-.07.34.029.533.304.533c.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598c-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081l.082-.381l2.29-.287zM8 5.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2z"/>
                    </g>
                </svg>
            </div>
            <div class="relative flex-grow max-w-full flex-1 px-4 pl-1">
                <span v-if="stateDefault">No Offers in <span class="cityName" v-html="regionName"></span>. </span>Showing
                Offers in <span class="cityName" v-html="offerStateName"></span>
            </div>
            <div class="col-auto">
                <img class="mr-1 closeTooltip" width="12" height="12"
                     src="https://objects.kaxmedia.com/auto/o/139689/9433bfc8e3.svg"/>
                <!--                <svg class="ml-1 closeTooltip" xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="20" height="20"
                                     preserveAspectRatio="xMidYMid meet" viewBox="0 0 50 50">
                                    <path d="M37.304 11.282l1.414 1.414l-26.022 26.02l-1.414-1.413z" fill="#777"/>
                                    <path d="M12.696 11.282l26.022 26.02l-1.414 1.415l-26.022-26.02z" fill="#777"/>
                                </svg>-->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'region-selector-tw',
    props: {
        showOfferAlert: {
            type: Boolean,
            default: true,
        },
        rankId: {
            type: Number,
            required: false,
        },
        defaultGeo: {
            type: String,
            required: true,
        },
        regionData: {
            type: Object,
            required: true,
        },
        sideBar: {
            type: Boolean,
            required: false,
            default: false,
        },
        emptyList: {
            type: Boolean,
            default: false,
        },
        regionHomepageLink: {
            type: String,
        },
        offerState: {
            type: String,
            required: false,
        },
        stateDefault: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            id: Math.floor(Math.random() * 100000),
            geoName: '',
            localGeo: this.defaultGeo,
            stateData: [],
            regionName: '',
            currentState: '',
            selectedStateName: '',
            flags: window.flags,
            noOfferAlert: true,
            noOfferAlertDisable: false,
            alert: true,
            alertDisable: false,
            showSelector: false,
            offerStateName: '',
            selectedRegion: {},
            ipCountry: document.querySelector('html').dataset.ipcountry
                ? document.querySelector('html').dataset.ipcountry.toUpperCase()
                : this.defaultGeo,
            regionCode: document.querySelector('html').dataset.regioncode
                ? document.querySelector('html').dataset.regioncode.toUpperCase()
                : this.currentState,
            expandTooltip: true,
        }
    },
    beforeMount: function () {
      this.selectedRegion = this.regionData[this.defaultGeo][this.regionCode];
      // Remove ON from selector for Non ON users
        if (this.regionCode != "ON") {
            this.regionData['CA'].supported_regions = this.regionData['CA'].supported_regions.filter(item => item.code !== "ON")
        }

        this.setDefaultState(this.defaultGeo)
        this.setStateData(this.defaultGeo)
        this.regionData[this.defaultGeo].supported_regions = this.regionData[this.defaultGeo].supported_regions.sort((a, b) => a.name.localeCompare(b.name))
        // this.regionData[this.defaultGeo] = this.regionData[this.defaultGeo].sort((a, b) => a.name.localeCompare(b.name));
    },
    mounted: function () {
        let region = this.currentState
        if ($cookies.isKey(('op_list_region_' + this.defaultGeo.toLowerCase()))) {
            region = $cookies.get(('op_list_region_' + this.defaultGeo.toLowerCase()))
          this.setStateData(this.defaultGeo)
        } else if ($cookies.isKey('op_list_region')) {
          //Need this to handle current CA cookie
            region = $cookies.get('op_list_region')
            this.setStateData(this.defaultGeo)
        }

        this.regionName = this.stateData.filter(state => {
            return state.code == region;
        })[0].name;

        if (this.offerState) {
            this.offerStateName = this.stateData.filter(state => {
                return state.code == this.offerState;
            })[0].name;
        }

      this.selectedRegion = this.regionData[geo].supported_regions.find(item => item.code === region);

        this.setDropdownSelectedOption(region);
        this.currentState = region;

        // Initialise the actual dropdown of the region selector
        // This used to be in select2-factory.js but the timeout of 200ms doesn't suit globally so calling the create function in here makes more sense
        // if (typeof select2Factory.create === "function") {
        //     select2Factory.create();
        // }

        // Init MicroModal
        MicroModal.init({
            targetModal: `stateSelectorModal-${this.id}`,
            openClass: 'modal-opened',
        });
    },
    computed: {
        isRestricted() {
            return this.ipCountry == 'CA' && this.regionCode == 'ON';
        }
    },
    methods: {
        changeRegion() {
            const urlParams = new URLSearchParams(window.location.search)
            // const newRegion = document.getElementById('state-select-' + this.id).value
            const newRegion = this.selectedRegion.code;

            $cookies.set('op_list_region_' + this.localGeo.toLowerCase(), newRegion)

            // to be removed when CloudFlare is working for US
            if (this.defaultGeo == "US") {
                $cookies.set('op_list_state', newRegion);
            }

            urlParams.set('regionCode', newRegion)
            urlParams.set('country', this.localGeo.toLowerCase())
            window.location.search = urlParams
        },
        setDropdownSelectedOption(state) {
            setTimeout(() => {
                if (document.getElementById('state-select-' + this.id)) {
                    document.getElementById('state-select-' + this.id).value = state;
                    document.getElementById('state-select-' + this.id).dispatchEvent(new Event('change'));
                }
            }, 1000);
        },
        setStateData(geo) {
            // const geo = value.code;
            this.localGeo = geo
            this.showSelector = window.flags[geo] ? true : false
            window.geoFlags = window.flags[geo]
            this.geoName = this.regionData[geo].region_name
            this.stateData = this.regionData[geo].supported_regions

        },
        setDefaultState(region) {
            this.currentState = this.regionData[region].default_region
        },
        openModal() {
            MicroModal.show(`stateSelectorModal-${this.id}`);
        },
        setSelectedState(value) {
          $(".update-state").css("display", "block");
          this.selectedRegion = value;
        }
    },
    watch: {
        offerState() {
            this.offerStateName = this.stateData.filter(state => {
                return state.code == this.offerState;
            })[0].name;
        }
    },
}
</script>

<style>

</style>
